/** Shared field styles for dashboard forms (light + dark). */
export const evoInputClassName =
  "w-full rounded-lg border border-evo-border bg-[var(--evo-bg)] px-3 py-2 text-sm text-evo-text placeholder:text-evo-subtle focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors disabled:opacity-50";

export const evoSelectClassName =
  "rounded-lg border border-evo-border bg-[var(--evo-bg)] px-3 py-2 text-sm text-evo-text focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-colors";

/** react-select styles that follow evo CSS variables (light + dark). */
export const reactSelectEvoStyles = {
  control: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--evo-surface)",
    borderColor: "var(--evo-border)",
    minHeight: "2.5rem",
  }),
  menu: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--evo-surface-elevated)",
  }),
  option: (base: Record<string, unknown>, state: { isFocused: boolean }) => ({
    ...base,
    backgroundColor: state.isFocused ? "var(--evo-hover)" : "transparent",
    color: "var(--evo-text)",
  }),
  singleValue: (base: Record<string, unknown>) => ({ ...base, color: "var(--evo-text)" }),
  multiValue: (base: Record<string, unknown>) => ({
    ...base,
    backgroundColor: "var(--evo-hover)",
  }),
  multiValueLabel: (base: Record<string, unknown>) => ({ ...base, color: "var(--evo-text)" }),
  input: (base: Record<string, unknown>) => ({ ...base, color: "var(--evo-text)" }),
};
